var _circle, _path, _ellipse, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgResellersIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7.5013,
    cy: 5.32747,
    r: 3.33333,
    stroke: "#858585",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M10.418 3.94473C10.8659 3.27111 11.6317 2.82715 12.5013 2.82715C13.882 2.82715 15.0013 3.94644 15.0013 5.32715C15.0013 6.70786 13.882 7.82715 12.5013 7.82715C11.6317 7.82715 10.8659 7.38319 10.418 6.70956",
    stroke: "#858585",
    strokeWidth: 1.5
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.5013,
    cy: 14.4935,
    rx: 5.83333,
    ry: 3.33333,
    stroke: "#858585",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M15 11.9941C16.4619 12.3147 17.5 13.1266 17.5 14.0775C17.5 14.9353 16.6552 15.6799 15.4167 16.0528",
    stroke: "#858585",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResellersIcon);
export default __webpack_public_path__ + "static/media/ResellersIcon.c3af49806440d41f870c1a966d754595.svg";
export { ForwardRef as ReactComponent };